import React from 'react';
import { Button } from './ui/button';
import ContactModal from './ContactModal';
import { ArrowRight } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="relative py-20 md:py-28 bg-[#1a2e4a] overflow-hidden grain-dark">
      {/* Decorative corner frames */}
      <div className="absolute top-0 left-0 w-24 h-24 md:w-32 md:h-32 border-l border-t border-white/[0.07]" />
      <div className="absolute bottom-0 right-0 w-24 h-24 md:w-32 md:h-32 border-r border-b border-white/[0.07]" />
      
      {/* Accent glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#10b981]/[0.04] rounded-full blur-[100px] pointer-events-none" />
      
      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8 md:gap-12">
          {/* Content */}
          <div className="space-y-4 md:max-w-xl">
            <h2 className="font-serif text-[1.75rem] sm:text-3xl md:text-4xl lg:text-[2.75rem] text-white leading-tight">
              Ready to protect what matters?
            </h2>
            <p className="text-slate-400 text-base md:text-lg leading-relaxed">
              Let's discuss how we can structure a comprehensive risk strategy tailored to your portfolio.
            </p>
          </div>

          {/* CTA Button */}
          <div className="flex-shrink-0">
            <ContactModal>
              <Button 
                className="w-full md:w-auto bg-[#10b981] hover:bg-[#059669] text-white font-semibold tracking-[0.1em] uppercase text-sm px-8 py-6 transition-all duration-300 group hover:shadow-lg hover:shadow-[#10b981]/25"
              >
                Get in Touch
                <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Button>
            </ContactModal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
